module.exports = __webpack_public_path__ + "925136e5.png";